import React from "react";
import Header from "../HeaderOne/Main";
import Footer from "../FooterOne/Main";
import Breadcrumb from "../Breadcrumb/Main";
import PartnerFive from "../Menabout/PartnerFive";
import CtaFive from "../Menabout/CtaFive";
import JoinusOne from "../Menabout/JoinusOne";
import TeamMemberOne from "../Menabout/TeamMemberOne";
import VideoTwo from "../Menabout/VideoTwo";
import AboutPage from "../Menabout/AboutPage";

function Main() {
  return (
    <div>
      <Header />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <div className="page-wrapper-bg-1" />
            <div className="page-wrapper-bg-2" />
            <main>
              <Breadcrumb title="Home" subtitle="About Company" />
              <AboutPage />
              <VideoTwo />
              <TeamMemberOne />
              <JoinusOne />
              <CtaFive />
              <PartnerFive />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
